"use client";

import { LoginForm } from "@/components/login-form";
import Image from "next/image";
import { useState } from "react";

export default function Page() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 4;

  const slides = [
    "/images/sign-in.svg",
    "/images/sign-in.svg",
    "/images/sign-in.svg",
    "/images/sign-in.svg",
  ];

  return (
    <div className="grid min-h-svh items-center justify-center px-4 sm:px-6 md:px-8 lg:px-0 max-w-[1440px] w-full mx-auto lg:grid-cols-2">
      {/* Left side - Image carousel (hidden on mobile/tablet) */}
      <div className="hidden lg:flex relative flex-col items-center justify-center">
        <div className="w-full max-w-[628px] h-[500px] xl:h-[700px] flex justify-center overflow-hidden">
          <div
            className="flex h-full transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div key={index} className="min-w-full h-full flex justify-center">
                <img
                  src={slide || "/placeholder.svg"}
                  alt={`Slide ${index + 1}`}
                  className="h-full object-cover transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 items-center">
          {[...Array(totalSlides)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`rounded-full transition-all duration-300 ease-in-out hover:scale-110 ${
                index === currentSlide
                  ? "bg-primary w-[14px] h-[14px] shadow-lg"
                  : "bg-[#424346] w-[10px] h-[10px] hover:bg-[#525256]"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Right side - Login form */}
      <div className="flex flex-col gap-4 w-full">
        <div className="flex flex-1 items-center justify-center py-8 sm:py-12 lg:py-0">
          <div className="w-full mx-auto flex flex-col items-center gap-6 sm:gap-8 md:gap-[50px] max-w-[90%] sm:max-w-[450px] md:max-w-[524px]">
            <Image
              alt="Neural Pilot"
              width={161}
              height={70}
              src={"/brand/logo.svg"}
              className="w-[120px] h-auto sm:w-[140px] md:w-[161px]"
            />
            <LoginForm className="w-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
